// adults
$('body').on('click', '.scholarships .add-adult-trigger', function() {
    var $this = $(this);
    var scholarships = $this.parents('.scholarships');
    var adult = $this.attr('data-adult');
    scholarships.find('.setup-adults').append(adult);
    return false;
});

$('body').on('click', '.scholarships .add-adult-trigger-before', function() {
	var $this = $(this);
    var scholarships = $this.parents('.scholarships');
    var adult = scholarships.find('.add-adult-trigger').attr('data-adult');
    $this.parents('.adult').before(adult);
    return false;
});

$('body').on('click', '.remove-adult-trigger', function() {
    var $this = $(this);
    $this.parents('.adult').remove();
    return false;
});

$('body').on('keydown', 'input[name="adults_amount[]"]', function(e) {
    if(e.keyCode === 9) {
    	var $this = $(this);
    	if($this.parents('.adult').is(':last-child')) {
    		e.preventDefault();
    		var scholarships = $this.parents('.scholarships');
    		scholarships.find('.add-adult-trigger').trigger('click');
    		$this.parents('.adult').next().find('input[name="adults_first_name[]"]').focus();
    	}
    }	    
});

// children
$('body').on('click', '.scholarships .add-child-trigger', function() {
    var $this = $(this);
    var scholarships = $this.parents('.scholarships');
    var child = $this.attr('data-child');
    scholarships.find('.setup-children').append(child);
    return false;
});

$('body').on('click', '.scholarships .add-child-trigger-before', function() {
    var $this = $(this);
    var scholarships = $this.parents('.scholarships');
    var child = scholarships.find('.add-child-trigger').attr('data-child');
    $this.parents('.child').before(child);
    return false;
});

$('body').on('click', '.remove-child-trigger', function() {
    var $this = $(this);
    $this.parents('.child').remove();
    return false;
});

// $('body').on('change', '.scholarships input[name="food_stamps"]', function() {
//     var $this = $(this);
//     var scholarships = $this.parents('.scholarships');

//     if($this.is(':checked')) {
//         scholarships.find('.add-child-trigger, .add-adult-trigger').hide();
//         scholarships.find('.setup-children').html('');
//         scholarships.find('.setup-adults').html('');
//         // hide the non foodstamps
//         $('.scholarships [data-food_stamps="true"]').removeClass('hidden');
//         $('.scholarships [data-food_stamps="true"]').each(function() {
//             var $this = $(this);
//             $this.find('input').prop('disabled', false);
//             $this.find('input').addClass('required');
//         });
       
//         $('.scholarships [data-food_stamps="false"]').addClass('hidden');
//         $('.scholarships [data-food_stamps="false"]').each(function() {
//             var $this = $(this);
//             $this.find('input').prop('disabled', true);
//             $this.find('input').removeClass('required');
//         });
//     } else {
//         scholarships.find('.add-child-trigger, .add-adult-trigger').show();
//         scholarships.find('.add-child-trigger').trigger('click');
//         scholarships.find('.add-adult-trigger').trigger('click');

//         $('.scholarships [data-food_stamps="false"]').removeClass('hidden');
//         $('.scholarships [data-food_stamps="false"]').each(function() {
//             var $this = $(this);
//             $this.find('input').prop('disabled', false);
//             $this.find('input').addClass('required');
//         });
       
//         $('.scholarships [data-food_stamps="true"]').addClass('hidden');
//         $('.scholarships [data-food_stamps="true"]').each(function() {
//             var $this = $(this);
//             $this.find('input').prop('disabled', true);
//             $this.find('input').removeClass('required');
//         });
//     }
// });

$('body').on('change', '.scholarships select[name="adults_earnings[]"]', function() {
    var $this = $(this);
    var adult = $this.parents('.adult');

    if($this.val() === 'none') {
        adult.find('input[name="adults_amount[]"]').val('0').parents('li').addClass('filled');
    }
});

$('body').on('change', '.add-update-scholarships [name="mode"]', function() {
    var $this = $(this);
    
    $('.add-update-scholarships .mode').removeClass('active');
    $('input, select', '.add-update-scholarships .mode').removeClass('required');

    $('.add-update-scholarships .mode[data-mode="'+$this.val()+'"]').addClass('active');
    $('input, select', '.add-update-scholarships .mode[data-mode="' + $this.val() + '"]').addClass('required');

});


$('body').on('submit', '.add-update-scholarships form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.error').removeClass('error');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                console.log(input.attr('name'));
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                console.log(input.attr('name'));
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
            input.addClass('error');
            console.log(input.attr('name'));
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            showError(data.success ? 'Success' : 'Error', data.message);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});